module.exports = __webpack_public_path__ + "img/develop4-3@2.eb8a4481.png";